import {
    MERCHANT_KYC_LIST_INITIATED,
    MERCHANT_KYC_FAILED,
    MERCHANT_KYC_LIST_LOADED,
  } from "../actions/MerchantKycAction";
  
  const initialState = {
    listdata: [],
    data: [],
    merchantCount : {
      active_count : 0,
      inactive_count : 0,
      pending_count : 0,
      total_count : 0,
    },
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    loading: false,
    error: null
  };
  
  const MerchantKycReducer = (state = initialState, action) => {
    switch (action.type) {
      case MERCHANT_KYC_LIST_INITIATED:
        return {
          ...state,
          data : {},
          loading: true,
          error: null,
        };
      case MERCHANT_KYC_LIST_LOADED:
        return {
          ...state,
          loading: false,
          data : [],
          listdata: action.payload
        };
      case MERCHANT_KYC_FAILED:
          return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default MerchantKycReducer;